import React, {useState, useEffect, useRef} from "react";
import { Row,Col } from 'react-bootstrap';
import styled from "styled-components";
import Button from "../../../globals/Button";
import ButtonGroup from "../../../globals/ButtonGroup";

import '../../../../assets/bootstrap/css/bootstrap.min.css'

const ToolBar = styled(Row)`
  min-height: 58px;
  margin:8px 0 8px 0;
  padding: 0;
  border: 1px solid #e4e4e4;
  background-color: #f7f7f7;
  align-items: center;
`;
const ButtonContainer = styled.div`
 
  display: flex;
  justify-content:end;
  button {
    margin: 8px;
  }
`;
const Separador = styled.span`
  width: 1px;
  min-width: 1px;
  height: 100%;
  background-color: #dfdfdf;
  margin: 0 8px;
  height: 28px;
`;
const Label = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0,0,0,.7);
  font-weight: normal;
  margin-right:8px;
`;
const ColS = styled(Col)`
  margin:0;
  padding: 0;

`;

function ToolbarGrid(props){
  
   /** Estados */
  
  const [showCalendar,setShowCalendar] = useState(false);

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
 
  /**
   * Hook that alerts clicks outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
              setShowCalendar(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
  }

  const clickCalendar = (e)=>{
    console.log(e);
    if(!props.isDetalleHistorico){
      setShowCalendar(!showCalendar);
    }
  };

  function toogleEstadoSwitch (){
    props.toogleEstadoSwitch(!props.estadoSwitch)
  }
  
  return (
    <ToolBar>
      
        
    </ToolBar>
  );
}
export default ToolbarGrid;